import { useLocation, useNavigate } from "react-router-dom";
import { Alert } from "react-bootstrap";
import "./HomePage.css";
import Footer from "../../Components/common/Footer";
import Header from "../../Components/common/Header";
import DynamicAnnouncement from "../../Components/common/DynamicAnnouncement";
import SocialMadia from "../../Components/common/SocialMadia";
import Fether from "../../layout/Fether";

import HeroSection from "../../layout/HeroSection";
import WhyChooseOurPlatform from "../../layout/WhyChooseOurPlatform";
import EducationLevelSection from "../../layout/EducationLevelSection";

import { useEffect, useState } from "react";
import { resolveMediaUrl } from "../../utils/mediaUrl";
import axios from "axios";
import { ACADEMICYEARID, baseURL } from "../../API/API";
import ImgFirst from "../../Imge/first_sec_bio.png";
import ImgSecond from "../../Imge/second_sec_bio.png";
import ImgThird from "../../Imge/third_sec_bio.png";
import FallbackImg from "../../Imge/about_2.png";
import TeacherImage from "../../Imge/about_2.png";
import L1Img from "../../Imge/l1.png";
import L2Img from "../../Imge/l2.png";
import { FaRegCalendarAlt, FaRegClock, FaStar } from "react-icons/fa";
import useAuth from "../hooks/useAuth";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const getCourseBadge = (name) => {
  if (!name) return null;
  const lowerName = name.toLowerCase();
  if (lowerName.includes("أزهر") || lowerName.includes("ازهر")) {
    return { text: "أزهري", type: "azhar" };
  }
  if (lowerName.includes("عام") || lowerName.includes("العام")) {
    return { text: "ثانوي عام", type: "general" };
  }
  if (lowerName.includes("معسكر") || lowerName.includes("انقاذ") || lowerName.includes("أنقاذ")) {
    return { text: "خصم مميز", type: "discount" };
  }
  if (lowerName.includes("مراجعة") || lowerName.includes("مراجعه") || lowerName.includes("نهائية") || lowerName.includes("نهائيه")) {
    return { text: "مراجعة نهائية", type: "revision" };
  }
  return null;
};

const getChapterImage = (name) => {
  if (!name) return FallbackImg;
  const lowerName = name.toLowerCase();
  if (lowerName.includes("معسكر النحو الشامل") && (lowerName.includes("عام") || lowerName.includes("العام"))) {
    return L1Img;
  }
  if (lowerName.includes("معسكر النحو الشامل") && (lowerName.includes("أزهر") || lowerName.includes("ازهر"))) {
    return L2Img;
  }
  if (lowerName.includes("أزهر") || lowerName.includes("ازهر")) {
    return ImgThird;
  }
  if (lowerName.includes("معسكر") || lowerName.includes("انقاذ") || lowerName.includes("أنقاذ")) {
    return ImgFirst;
  }
  if (lowerName.includes("مراجعة") || lowerName.includes("مراجعه") || lowerName.includes("نهائية") || lowerName.includes("نهائيه")) {
    return ImgSecond;
  }
  return FallbackImg;
};

const getChapterDescription = (name) => {
  if (!name) return "شرح تفصيلي متكامل لمنهج اللغة العربية مع تدريبات تفاعلية مستمرة لضمان تحقيق الدرجة النهائية.";
  const lowerName = name.toLowerCase();
  if (lowerName.includes("أزهر") || lowerName.includes("ازهر")) {
    return "شرح شامل ومفصل لمنهج اللغة العربية لطلاب الثانوية الأزهرية (النحو، الصرف، البلاغة، الأدب والنصوص) مع امتحانات دورية قوية.";
  }
  if (lowerName.includes("عام") || lowerName.includes("العام")) {
    return "كورس اللغة العربية المتكامل لطلاب الثانوية العامة، شرح وتأسيس متكامل لكافة الفروع مع تطبيقات معادلات الهندسة النحوية المتميزة.";
  }
  if (lowerName.includes("معسكر") || lowerName.includes("انقاذ") || lowerName.includes("أنقاذ")) {
    return "معسكر الإنقاذ السريع! لمّ منهج النحو والبلاغة بالكامل في أسبوع واحد فقط بأسلوب الهندسة النحوية المبتكر وبسعر مميز.";
  }
  if (lowerName.includes("مراجعة") || lowerName.includes("مراجعه") || lowerName.includes("نهائية") || lowerName.includes("نهائيه")) {
    return "المراجعة النهائية الشاملة في اللغة العربية لكافة الفروع، مع أقوى بنك أسئلة ونماذج امتحانات تفاعلية تحاكي الامتحان النهائي.";
  }
  return "شرح تفصيلي متكامل لمنهج اللغة العربية مع تدريبات تفاعلية مستمرة لضمان تحقيق الدرجة النهائية.";
};

const getChapterDates = (name) => {
  if (!name) return { startDate: "الاثنين، 6 أبريل", startTime: "02:00 م" };
  const lowerName = name.toLowerCase();
  if (lowerName.includes("معسكر") || lowerName.includes("انقاذ") || lowerName.includes("أنقاذ")) {
    return { startDate: "الخميس، 12 يناير", startTime: "05:00 م" };
  }
  return { startDate: "الاثنين، 6 أبريل", startTime: "02:00 م" };
};

const processCourses = (data) => {
  return data.map((course) => {
    const name = course.name || "";
    let price = 150;
    let description = getChapterDescription(name);

    if (name.includes("معسكر النحو الشامل") && (name.includes("عام") || name.includes("العام"))) {
      price = 250;
      description = "معسكر النحو الشامل لطلاب الثانوية العامة - شرح كامل وتدريبات مكثفة على جميع قواعد النحو والاعراب.";
    } else if (name.includes("معسكر النحو الشامل") && (name.includes("أزهر") || name.includes("ازهر"))) {
      price = 250;
      description = "معسكر النحو الشامل لطلاب الثانوية الأزهرية - شرح كامل وتدريبات مكثفة متوافقة مع منهج الأزهر الشريف.";
    } else if (name.includes("الأول") || name.includes("اول")) {
      price = 125;
    } else if (name.includes("الثاني") || name.includes("تانى") || name.includes("ثانى")) {
      price = 150;
    } else if (name.includes("الثالث") || name.includes("تالت")) {
      price = 200;
    }

    const dates = getChapterDates(course.name);
    return {
      ...course,
      academic_year_id: course.academic_year_id || course.id,
      price: course.price || price,
      image: resolveMediaUrl(course.image_path) || course.image || getChapterImage(course.name),
      description: course.description || description,
      startDate: course.startDate || dates.startDate,
      startTime: course.startTime || dates.startTime,
    };
  });
};

const testimonials = [
  { name: "أحمد محمد", level: "ثالثة ثانوي عام", text: "الهندسة النحوية غيرت طريقتي في حل النحو تماماً، النحو بقى أسهل من الرياضيات بفضل معادلات مستر محمود الصبروط", stars: 5 },
  { name: "فاطمة علي", level: "تانية ثانوي أزهري", text: "منهج البلاغة والصرف كان كابوس بالنسبة لي، بس مع شرح مستر محمود الصبروط بقيت أحل الامتحانات وأنا واثقة جداً", stars: 5 },
  { name: "عمر حسن", level: "أولى ثانوي عام", text: "الشرح مبسط وممتع جداً، والمنصة منظمة وبتخليني أحب لغتنا العربية وأفهمها مش بس أحفظ القواعد", stars: 5 },
  { name: "مريم خالد", level: "ثالثة ثانوي أزهري", text: "شعار «نُوحٌ نَحوَ نَحوٍ جَدِيدٍ» حقيقة ملموسة! قدرت أقفل امتحان العربي التجريبي بفضل المتابعة والتدريبات القوية", stars: 5 },
  { name: "يوسف سامي", level: "تانية ثانوي عام", text: "الامتحانات الدورية وبنك الأسئلة ساعدوني أعرف مستواي وأتحسن أول بأول، شكراً نوح أكاديمي ومساعدين مستر محمود", stars: 5 },
  { name: "نورا إبراهيم", level: "أولى ثانوي أزهري", text: "أفضل منصة لتعليم اللغة العربية بالأزهر، الشرح وافي جداً وبيراعي كل تفاصيل المنهج الأزهري والشرعي", stars: 5 },
  { name: "كريم طارق", level: "ثالثة ثانوي عام", text: "محاضرات ليالي الامتحان والمراجعة المركزة هي اللي أنقذتني، قدرت أراجع فروع العربي كلها في وقت قياسي وبثقة كاملة", stars: 5 },
  { name: "سارة وليد", level: "تانية ثانوي أزهري", text: "متابعة ولي الأمر خلت والدي مبسوط جداً وبيتابع تقارير أدائي ودرجاتي في اختبارات اللغة العربية أسبوعياً", stars: 5 },
  { name: "محمود عادل", level: "أولى ثانوي عام", text: "المعادلات النحوية سهلت علينا القواعد، النحو مبقاش حفظ وتلقين، النحو فهم هندسي ممتاز وممتع مع مستر محمود الصبروط", stars: 5 },
  { name: "هنا أحمد", level: "ثالثة ثانوي أزهري", text: "المنصة وتطبيقها ممتازة جداً وسهلة، الشرح عميق وأسلوب مستر محمود الصبروط يخليك تحب المادة وتتفوق فيها بسهولة", stars: 5 },
];

const fallbackCourses = [
  { id: 101, name: "كورس اللغة العربية - الصف الأول الثانوي (عام)", price: 125, academic_year_id: 16 },
  { id: 102, name: "كورس اللغة العربية - الصف الثاني الثانوي (عام)", price: 150, academic_year_id: 13 },
  { id: 103, name: "كورس اللغة العربية - الصف الثالث الثانوي (عام)", price: 200, academic_year_id: 12 },
  { id: 104, name: "كورس اللغة العربية - الصف الأول الثانوي (أزهر)", price: 125, academic_year_id: 10 },
  { id: 105, name: "كورس اللغة العربية - الصف الثاني الثانوي (أزهر)", price: 150, academic_year_id: 14 },
  { id: 106, name: "كورس اللغة العربية - الصف الثالث الثانوي (أزهر)", price: 200, academic_year_id: 11 },
];

export default function HomePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { auth } = useAuth();
  const unauthorized = location.state?.unauthorized;
  const [courses, setCourses] = useState([]);

  const handleCourseClick = (course) => {
    const stageId = course.academic_year_id || 10;
    if (!auth?.accessToken) {
      toast.info("يرجى إنشاء حساب أو تسجيل الدخول لعرض محتوى الكورس");
      navigate("/register", { state: { selectedStageId: stageId } });
      return;
    }
    if (auth.user?.is_staff) {
      navigate(`/learn/${stageId}`);
      return;
    }
    const enrolledId = auth.user?.academic_year_id;
    if (Number(stageId) !== Number(enrolledId)) {
      toast.error("أنت لست مسجلاً في هذه المرحلة. يمكنك فقط الدخول إلى مرحلتك المسجلة.");
      return;
    }
    navigate(`/learn/${stageId}`);
  };

  const handleSubscribeClick = (course) => {
    const stageId = course.academic_year_id || 10;
    if (!auth?.accessToken) {
      toast.info("يرجى إنشاء حساب أو تسجيل الدخول لعرض الفاتورة والاشتراك");
      navigate("/register", { state: { selectedStageId: stageId } });
      return;
    }
    navigate(`/invoice/${stageId}`, {
      state: {
        price: Number(course.price ?? 150),
        discount: Number(course.discount ?? 0),
        courseName: course.name,
      },
    });
  };

  useEffect(() => {
    axios
      .get(`${baseURL}/learning/chapters/all`)
      .then((chResponse) => {
        const chData = (chResponse.data?.data || []).filter((ch) => !ch.is_draft);
        if (chData.length > 0) {
          const mapped = processCourses(chData);
          if (mapped.length < 6) {
            const duplicated = [];
            while (duplicated.length < 6) duplicated.push(...mapped);
            setCourses(duplicated.slice(0, 6));
          } else {
            setCourses(mapped);
          }
        } else {
          fetchAcademics();
        }
      })
      .catch((err) => {
        console.error("Error fetching chapters, trying academics:", err);
        fetchAcademics();
      });

    function fetchAcademics() {
      axios
        .get(`${baseURL}/learning/academics`)
        .then((response) => {
          const data = response.data?.data || [];
          if (data.length > 0) {
            const mapped = processCourses(data);
            if (mapped.length < 6) {
              const duplicated = [];
              while (duplicated.length < 6) duplicated.push(...mapped);
              setCourses(duplicated.slice(0, 6));
            } else {
              setCourses(mapped);
            }
          } else {
            setCourses(processCourses(fallbackCourses));
          }
        })
        .catch((error) => {
          console.error("Error fetching academics for landing page:", error);
          setCourses(processCourses(fallbackCourses));
        });
    }
  }, []);

  return (
    <>
      <Header />
      <DynamicAnnouncement />

      {unauthorized && (
        <Alert variant="danger" className="m-3">
          غير مصرح لك بالدخول
        </Alert>
      )}

      {/* 1. Hero — لفت الانتباه فوراً */}
      <HeroSection />

      {/* 2. المراحل الدراسية — "هل ده ليّا؟" */}
      <EducationLevelSection />

      {/* 3. اختيار الصف — تحويل الاهتمام لخطوة فعلية */}
      <section className="grade-selection-section" dir="rtl">
        <div className="container">
          <h2 style={{ fontWeight: 900, fontSize: "1.9rem", color: "#111827", marginBottom: "40px" }} className="text-center">
            اختار السنة الدراسية وادخل علي الكورسات المتاحة لدفعة 2026
          </h2>
          <div className="grade-cards-grid">
            <div className="grade-selection-card" onClick={() => navigate("/courses/grade/1")}>
              <div className="card-title-text">الصف الدراسي الأول</div>
              <div className="card-link-text">← جميع كورسات الصف الأول الثانوي</div>
            </div>
            <div className="grade-selection-card" onClick={() => navigate("/courses/grade/2")}>
              <div className="card-title-text">الصف الدراسي الثاني</div>
              <div className="card-link-text">← جميع كورسات الصف الثاني الثانوي</div>
            </div>
            <div className="grade-selection-card" onClick={() => navigate("/courses/grade/3")}>
              <div className="card-title-text">الصف الدراسي الثالث</div>
              <div className="card-link-text">← جميع كورسات الصف الثالث الثانوي</div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. لماذا تختارنا — بناء الثقة */}
      <WhyChooseOurPlatform />

      {/* 5. المميزات التفصيلية — تعمق في القيمة */}
      <Fether />

      {/* 6. الكورسات المقترحة — المستخدم مقتنع، دلوقتي يشوف المنتج */}
      <section className="suggested-courses-section" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container mb-4">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3" dir="rtl">
            <h2 style={{ fontWeight: 900, fontSize: "1.55rem", margin: 0, color: "#111827" }}>
              كورساتنا المقترحة للعام 2025/2026
            </h2>
            <div className="filter-pills">
              <button className="btn-filter-pill active">الكل</button>
            </div>
          </div>
        </div>

        <div className="suggested-courses-slider-wrapper">
          {courses.length > 0 ? (
            <Swiper
              dir="rtl"
              modules={[Autoplay, Navigation, Pagination]}
              loop={true}
              navigation={true}
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              breakpoints={{
                0: { slidesPerView: 1.1, spaceBetween: 12 },
                480: { slidesPerView: 1.4, spaceBetween: 14 },
                768: { slidesPerView: 2.1, spaceBetween: 16 },
                1024: { slidesPerView: 3.05, spaceBetween: 18 },
                1400: { slidesPerView: 3.2, spaceBetween: 18 },
              }}
            >
              {courses.map((course) => {
                const badgeInfo = getCourseBadge(course.name);
                return (
                  <SwiperSlide key={course.id} style={{ height: "auto" }}>
                    <div className="suggested-course-card">
                      <div className="course-image-wrapper">
                        <img src={course.image} alt={course.name} />
                        {badgeInfo && (
                          <span className={`course-image-badge badge-${badgeInfo.type}`}>
                            {badgeInfo.text}
                          </span>
                        )}
                      </div>
                      <div className="course-card-body">
                        <h3 className="course-card-title">{course.name}</h3>
                        {Number(course.discount) > 0 ? (
                          <div className="course-card-price text-end w-100 mb-2" style={{ direction: "rtl" }}>
                            <div className="text-primary-500 fw-bold text-end mb-1" style={{ color: "var(--brand-300)", fontSize: "1.35rem" }}>
                              {Number(course.price) - Number(course.discount)} جنيه
                            </div>
                            <div className="d-flex flex-row gap-1 justify-content-start align-items-center text-muted small" style={{ fontSize: "0.88rem" }}>
                              <span className="text-gray-600 dark:text-gray-200 smooth opacity-75">بدلاً من</span>
                              <span className="text-decoration-line-through text-danger fw-semibold" style={{ color: "#dc3545", fontWeight: "600" }}>{Number(course.price)} جنيهاً</span>
                            </div>
                          </div>
                        ) : (
                          <div className="course-card-price">{course.price} جنيه</div>
                        )}
                        <div className="course-card-details-row">
                          <div className="course-card-desc-col">
                            <p className="course-card-desc">
                              {course.description}
                              <span onClick={() => handleCourseClick(course)} className="course-card-details-link">
                                {" "}... عرض باقي التفاصيل
                              </span>
                            </p>
                          </div>
                          <div className="course-meta-info-col">
                            <div className="course-meta-item">
                              <FaRegCalendarAlt className="meta-icon" />
                              <span>{course.startDate}</span>
                            </div>
                            <div className="course-meta-item">
                              <FaRegClock className="meta-icon" />
                              <span>{course.startTime || course.startDate}</span>
                            </div>
                          </div>
                        </div>
                        <div className="course-card-buttons">
                          <button onClick={() => handleCourseClick(course)} className="btn-enter-course">
                            الدخول للكورس
                          </button>
                          <button onClick={() => handleSubscribeClick(course)} className="btn-subscribe-course">
                            الإشتراك في الكورس !
                          </button>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          ) : (
            <div className="text-center py-5" style={{ color: "#9ca3af" }}>
              جاري تحميل الكورسات...
            </div>
          )}
        </div>
      </section>

      {/* 7. آراء الطلاب — Social Proof بعد ما شاف المنتج */}
      <section style={{ padding: "60px 0", background: "#f8f9fa" }}>
        <h2 className="text-center fw-bold mb-5 fs-3">ماذا يقول طلابنا؟</h2>
        <div className="testimonials-wrapper" dir="ltr">
          <div className="testimonials-track">
            {[...testimonials, ...testimonials].map((t, i) => (
              <div
                key={i}
                className="bg-third-container clr-text-primary smooth rounded-xl p-4 d-flex flex-column gap-3 testimonial-card"
                style={{ minWidth: "320px", maxWidth: "320px" }}
                dir="rtl"
              >
                <div className="d-flex gap-1" style={{ color: "var(--brand-200-alt, #cca245)", fontSize: "16px" }}>
                  {Array.from({ length: t.stars }).map((_, index) => (
                    <FaStar key={index} />
                  ))}
                </div>
                <p className="small clr-text-secondary" style={{ lineHeight: "1.7" }}>"{t.text}"</p>
                <div className="mt-auto">
                  <div className="font-bold">{t.name}</div>
                  <div className="small clr-text-secondary">{t.level}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 8. CTA — الدعوة للتسجيل بعد الاقتناع الكامل */}
      <section className="py-5 px-3 bg-white">
        <div className="container">
          <div
            className="cta-banner-wrapper d-flex align-items-center justify-content-between p-4 p-md-5 rounded-4 position-relative overflow-hidden"
            dir="rtl"
          >
            <div className="cta-banner-content text-end">
              <h2 className="cta-banner-title fw-bold mb-3">إبدأ رحلة تحقيق حلمك دلوقتي ✨</h2>
              <p className="cta-banner-subtitle mb-4">جرّب أول محاضرة مجاناً وشوف الفرق بنفسك.</p>
              <button className="btn-cta-banner-action" onClick={() => (window.location.href = "/register")}>
                ابدأ رحلتك
              </button>
            </div>
            <div className="cta-banner-image-container d-none d-md-block">
              <img src={TeacherImage} alt="المعلم" className="cta-banner-img" />
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <SocialMadia />
    </>
  );
}